import { Close, EditOutlined } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { setGeofenceChangedItem, setGeofenceUpdateItem } from 'app/actions/map';
import { Protect } from 'app/components';
import { ChangeGeofenceShapeIcon, DeleteIcon } from 'app/icons';
import React from 'react';
import { Popup } from 'react-leaflet';
import { useDispatch } from 'react-redux';
const MapLeafletGeofencePopup = (props) => {
    const dispatch = useDispatch();
    const { value, onClose } = props;
    const handleChangeClick = (value) => dispatch(setGeofenceChangedItem(value));
    const handleUpdateClick = (value) => dispatch(setGeofenceUpdateItem(value));
    const handleDeleteClick = (value) => dispatch(setGeofenceUpdateItem(Object.assign(Object.assign({}, value), { delete: true })));
    return (React.createElement(Popup, Object.assign({ className: 'leaflet-popup-geofence' }, config.mapPopupOptions),
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                fontSize: '12px',
                bgcolor: 'background.paper',
                overflow: 'hidden',
                borderRadius: theme.shape.borderRadius,
            }) },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: {
                    padding: '10px 0',
                    bgcolor: 'background.default',
                    minHeight: '44px',
                    '.MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        margin: '0 12px',
                        width: '100%',
                        padding: '0 82px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        fontSize: '13px',
                    },
                } },
                React.createElement(Stack, { direction: 'row', alignItems: 'center', component: 'ul', sx: (theme) => ({
                        position: 'absolute',
                        left: '-30px',
                        top: '7px',
                        margin: '0',
                        marginLeft: 'auto',
                        listStyle: 'none',
                        li: {
                            margin: '0',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            button: {
                                width: '30px',
                                height: '30px',
                                '.maximizeIcon, .minimizeIcon': {
                                    width: '16px',
                                    height: '16px',
                                },
                            },
                        },
                        'li:nth-of-type(1) svg': {
                            fontSize: '16px',
                            path: {
                                fill: theme.palette.text.secondary,
                            },
                        },
                        'li:nth-of-type(2) svg': {
                            fontSize: '17px',
                        },
                        'li:not(:last-of-type) path': {
                            fill: theme.palette.text.secondary,
                        },
                    }) },
                    React.createElement(Protect, { permissions: 'update', renderPermitted: () => (React.createElement("li", null,
                            React.createElement(IconButton, { color: 'default', onClick: () => handleChangeClick(value) },
                                React.createElement(ChangeGeofenceShapeIcon, { fontSize: 'small' })))), renderForbidden: () => React.createElement(React.Fragment, null) }),
                    React.createElement(Protect, { permissions: 'update', renderPermitted: () => (React.createElement("li", null,
                            React.createElement(IconButton, { color: 'default', onClick: () => handleUpdateClick(value) },
                                React.createElement(EditOutlined, { fontSize: 'small' })))), renderForbidden: () => React.createElement(React.Fragment, null) })),
                React.createElement(Typography, { variant: 'body1', sx: Object.assign({ position: 'absolute', width: '332px !important' }, (value.name.length >= 20 && {
                        left: '-14px',
                    })) }, value.name),
                React.createElement(Stack, { direction: 'row', alignItems: 'center', component: 'ul', sx: (theme) => ({
                        position: 'absolute',
                        right: '8px',
                        top: '7px',
                        margin: '0',
                        marginLeft: 'auto',
                        listStyle: 'none',
                        li: {
                            margin: '0',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            button: {
                                width: '30px',
                                height: '30px',
                                '.maximizeIcon, .minimizeIcon': {
                                    width: '16px',
                                    height: '16px',
                                },
                            },
                        },
                        'li:nth-of-type(1) svg': {
                            fontSize: '16px',
                            path: {
                                fill: theme.palette.text.secondary,
                            },
                        },
                        'li:nth-of-type(2) svg': {
                            fontSize: '17px',
                        },
                        'li:not(:last-of-type) path': {
                            fill: theme.palette.text.secondary,
                        },
                    }) },
                    React.createElement(Protect, { permissions: 'delete', renderPermitted: () => (React.createElement("li", null,
                            React.createElement(IconButton, { color: 'default', onClick: () => handleDeleteClick(value) },
                                React.createElement(DeleteIcon, { fontSize: 'small' })))), renderForbidden: () => React.createElement(React.Fragment, null) }),
                    React.createElement("li", null,
                        React.createElement(IconButton, { className: 'leaflet-popup-close-button', color: 'default', onClick: onClose },
                            React.createElement(Close, { fontSize: 'small' }))))),
            React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                    display: 'grid',
                    gap: 2,
                    padding: theme.spacing(2),
                    '.MuiPaper-root': {
                        position: 'relative',
                        border: 'none',
                    },
                    '.MuiPaper-row': {
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(5, 1fr)',
                        '.MuiTypography-root:first-of-type': {
                            color: 'text.secondary',
                        },
                    },
                    '.MuiPaper-row .MuiTypography-root:first-of-type': {
                        gridRow: '1',
                        gridColumn: '1/3',
                    },
                    '.MuiPaper-row .MuiTypography-root:last-of-type': {
                        gridRow: '1',
                        gridColumn: '3/6',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        'span:nth-of-type(2)': {
                            paddingLeft: theme.spacing(0.5),
                        },
                    },
                }) },
                React.createElement(Paper, { variant: 'outlined' },
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0413\u0440\u0443\u043F\u043F\u0430"),
                        React.createElement(Typography, { variant: 'body1' }, value.group)),
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u041C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435"),
                        React.createElement(Typography, { variant: 'body1' },
                            value.latitude,
                            ", ",
                            value.longitude)),
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0410\u0434\u0440\u0435\u0441"),
                        React.createElement(Typography, { variant: 'body1' }, value.location)),
                    value.shape === 'Circle' && (React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0428\u0438\u0440\u0438\u043D\u0430"),
                        React.createElement(Typography, { variant: 'body1' },
                            React.createElement("span", null, value.radius),
                            React.createElement("span", null, "\u043C")))),
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u041F\u043B\u043E\u0449\u0430\u0434\u044C"),
                        React.createElement(Typography, { variant: 'body1' },
                            React.createElement("span", null, value.area),
                            React.createElement("span", null, "\u043C\u00B2"))))))));
};
export default MapLeafletGeofencePopup;
